"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardApiController = void 0;
const components_1 = require("@veeam/components");
require("./types");
class WizardApiController extends components_1.ComponentApiController {
    switchStepByTag(tag) {
        return this.callApi((api) => {
            return api.switchStepByTag(tag);
        });
    }
}
exports.WizardApiController = WizardApiController;
//# sourceMappingURL=WizardApiController.js.map